/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Device operating system type enumeration.
 */
export enum DeviceOSType {
    IOS = 'ios',
    ANDROID = 'android',
    WINDOWS = 'windows',
    MACOS = 'macos',
    LINUX = 'linux',
    WEB = 'web',
    OTHER = 'other',
}
